import type { SVGProps } from 'react'

interface BiomassIconProps extends SVGProps<SVGSVGElement> {}

export function BiomassIcon(props: BiomassIconProps) {
  return (
    <svg
      width="34"
      height="31"
      viewBox="0 0 34 31"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_2015_307)">
        <path d="M1.08574 29.0625H7.86476V25.0342C4.07748 26.3781 0 23.8143 0 20.1301C0 18.0759 1.28715 16.291 3.20496 15.4181C2.75134 12.2687 5.44432 9.46625 8.92719 9.46625C12.408 9.46625 15.1035 12.2658 14.6494 15.4181C14.9753 15.5664 15.2856 15.7433 15.5759 15.9445C13.5745 18.4587 13.6031 21.8358 15.5774 24.3152C13.9244 25.4654 11.8004 25.6768 9.98963 25.0342V29.0625H15.9375V26.412C16.4452 26.1514 16.7422 25.942 17.0582 25.7221C17.3745 25.951 17.7094 26.1596 18.0625 26.3425V29.0625H24.0102V25.0342C20.223 26.3782 16.1455 23.8143 16.1455 20.1301C16.1455 18.0759 17.4326 16.291 19.3504 15.4181C18.8968 12.2687 21.5898 9.46625 25.0727 9.46625C28.5535 9.46625 31.249 12.2658 30.7949 15.4181C32.7156 16.2922 34 18.0788 34 20.1301C34 23.8203 29.9157 26.3758 26.1352 25.0342V29.0625H32.9143C33.501 29.0625 33.9768 29.4962 33.9768 30.0312C33.9768 30.5663 33.501 31 32.9143 31H1.08574C0.498977 31 0.0232426 30.5663 0.0232426 30.0312C0.0232426 29.4962 0.498977 29.0625 1.08574 29.0625Z" />
        <path d="M17.2508 14.4005C17.1851 14.445 17.1205 14.4907 17.0564 14.537C16.8353 14.3837 16.8411 14.3876 16.8141 14.3692C16.6193 10.7713 13.5141 7.86032 9.60554 7.55564C9.79559 7.45368 9.99069 7.35959 10.1904 7.27465C9.52425 3.43761 12.7911 0 17 0C21.2102 0 24.4756 3.43894 23.8095 7.27459C24.0434 7.37406 24.2708 7.48608 24.4912 7.6088C20.5627 7.87303 17.4308 10.7921 17.2508 14.4005Z" />
      </g>
      <defs>
        <clipPath id="clip0_2015_307">
          <rect width="34" height="31" transform="matrix(-1 0 0 1 34 0)" />
        </clipPath>
      </defs>
    </svg>
  )
}
